export interface IMoreMenuMobileActions {
    label: string;
    action: () => void;
    isDisabled: () => boolean;
}

export class MoreMenuMobileSettingsModel {
    MobileMoreOpened = false;
    ListItems: IMoreMenuMobileActions[] = [];

    ToggleMobileMore() {
        this.MobileMoreOpened = !this.MobileMoreOpened;
    }

    AddListItem(label: string, itemAction, isDisabled?) {
        this.ListItems.push({
            label: label,
            action: () => {
                if (itemAction) {
                    setTimeout(() => itemAction(), 0);
                }
                this.MobileMoreOpened = false;
            },
            isDisabled: () => {
                return isDisabled ? isDisabled() : false;
            },
        });
    }
}
